import React from "react";
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from "moment";
import {FormattedMessage} from "react-intl";

import MonthView from "./monthView";
import TimeTableView from "./timeTableView";
import Analytics from './../../../analytics';
import Misc from "../../../misc/misc";
import store from "../../../store";
import {SHOW_SCHEDULER} from "../../../actions/actionTypes";
import {scheduleCustomer} from "../../../api/user-api";

class ConfirmationScheduleView extends React.Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    static propTypes = {
        cancel: PropTypes.func
    };

    state = {
        selectedDate: moment(),
        time: 10,
        aptType: 'apt' // apt | home-estimate
    };


    /**
     *
     * @param date {moment}
     */
    handleMonthDayChange = (date) => {
        Analytics.sendDataEnteredEvent('calendar-date-change');
        this.setState({selectedDate: date});
    };

    handleTimeTableTimeChange = (time, aptType) => {
        Analytics.sendDataEnteredEvent('calendar-time-aptType-change');
        this.setState({
            time: time,
            aptType: aptType
        });
    };

    handleCancelClick = (e) => {
        Analytics.sendClickEvent('calendar-cancel');
        Misc.ignoreDefault(e);
        store.dispatch({type: SHOW_SCHEDULER, payload: {show: false}});
        this.setState({visible: false});
        if (this.props.cancel) {
          this.props.cancel();
        }
    };

    handleScheduleClick = (e) => {
        Analytics.sendClickEvent('calendar-schedule');
        Misc.ignoreDefault(e);
        scheduleCustomer({
            date: this.state.selectedDate.format('MM/DD/Y'),
                time: this.state.time * 100,
                aptType: this.state.aptType
            });
        //JsonApi.scheduleCustomer(this.state.selectedDate.format('MM/DD/Y'), this.state.time * 100, this.state.aptType);
    };

    render() {
        return (
            <div className="lightbox-container lightbox-container--confirmation">
                <div className="lightbox-wrapper">
                    <div className="lightbox-header-container">
                        <div className="lightbox-title-block">
                            <h6><FormattedMessage id="confirmationScheduleView.title"/></h6>
                            <p><FormattedMessage id="confirmationScheduleView.text"/></p>
                        </div>
                        {this.props.windowWidth >= 768 ? (
                          <div className="lightbox-button-block">
                              <button className="ui-button ui-button--blue" onClick={this.handleCancelClick}>
                                  <span className="ui-button-text ui-button--uppercase">
                                    <FormattedMessage id="confirmationScheduleView.noAppointmentButton"/>
                                  </span>
                              </button>
                              <button className="ui-button ui-button--green" onClick={this.handleScheduleClick}>
                                  <span className="ui-button-text ui-button--uppercase">
                                    <FormattedMessage id="confirmationScheduleView.scheduleButton"/>
                                  </span>
                              </button>
                          </div>
                        ) : null}
                    </div>
                    <div className="confirmation-content-wrapper">
                        <div className="confirmation-container">
                            <MonthView dateChanged={this.handleMonthDayChange} selectedDate={this.state.selectedDate}/>
                            <TimeTableView date={this.state.selectedDate} timeChanged={this.handleTimeTableTimeChange}
                                           time={this.state.time} aptType={this.state.aptType}/>
                        </div>
                        {this.props.windowWidth < 768 ? (
                          <div className="lightbox-button-block">
                              <button className="ui-button ui-button--blue" onClick={this.handleCancelClick}>
                                  <span className="ui-button-text ui-button--uppercase">
                                    <FormattedMessage id="confirmationScheduleView.noAppointmentButton"/>
                                  </span>
                              </button>
                              <button className="ui-button ui-button--green" onClick={this.handleScheduleClick}>
                                  <span className="ui-button-text ui-button--uppercase">
                                    <FormattedMessage id="confirmationScheduleView.scheduleButton"/>
                                  </span>
                              </button>
                          </div>
                        ) : null}
                        <div className="confirmation-bottom-text">
                          <FormattedMessage id="confirmationScheduleView.confirmationText"/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => ({
    windowWidth: store.serverState.windowWidth,
});
export default connect(mapStateToProps)(ConfirmationScheduleView);
